import {logger} from 'utils';

type NotificationResult = {
    success: boolean,
    error: any
};

export const ParentWindowNotifierService = {
    notify: (payload: any): NotificationResult => {
        const parent = window.opener || window.parent;
        if (!parent) {
            const message = 'Unable to send an event to opener';
            logger.warn(message);
            return {
                success: false,
                error: {message}
            };
        }
        try {
            parent.postMessage(payload, '*');
            return {
                success: true,
                error: null
            };
        } catch (error: any) {
            logger.warn(error.message);
            return {
                success: false,
                error: {message: 'Failed to call "parent.postMessage"', details: error}
            };
        }
    }
};